module.exports = __webpack_public_path__ + "static/Inter-SemiBold-28534027095c3302c6d8968a172eb7b0.woff";